/**
 * web端唤起pc端使用协议
 * 历史原因：newSSOLogin指的sso登录，包括cas、oauth、oidc协议
 */

export const protocolNameMap: Readonly<Record<string, string>> = {
  ssoLogin: 'newSSOLogin',
  yufuLogin: 'idassLogin',
};

export const protocolUrlMap: Readonly<Record<string, string>> = {
  // sso登录拉起pc
  ssoLogin: 'cofile://newSSOLogin/',
  // yufu登录拉起pc
  yufuLogin: 'cofile://idassLogin/',
  // 批量下载拉起pc
  download: 'cofile://download/',
};
